module.exports = __webpack_public_path__ + "static/media/cat-picture.60f80f0f.png";